import React, { useState, useEffect, ReactNode } from 'react';
import { Table } from "react-bootstrap";
import axios from "axios";
import styles from "./Bank.module.scss";

interface BankInterface {
  financial: string;
  bank_code: string;
  branch: string;
  branch_code: string;
  deposit_type: string;
  account_number: string;
  account_name: string;
};

interface BankProps {
  topChildren: ReactNode;
  bottomChildren: ReactNode;
  onSubmit: (e: React.FormEvent) => Promise<void>;
  isValid: boolean
};

const Bank = (props: BankProps) => {
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [banks, setBanks] = useState<Array<BankInterface>>([]);

  useEffect(() => {
    (async () => {
      const res = await axios.get('/api/banks')
      setBanks(res.data);
    })();
  }, []);

  const handleOnSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isProcessing) return;
    setIsProcessing(true);
    try {
      await props.onSubmit(e);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <form onSubmit={handleOnSubmit} className={styles.form}>
      {props.topChildren}

      <h5 className="mb-2">銀行振込振込先</h5>

      {banks.map(bank => (
        <Table>
          <tbody>
            <tr>
              <th className="text-nowrap">金融機関</th>
              <td>{bank.financial} ({bank.bank_code})<br />{bank.branch} ({bank.branch_code})</td>
            </tr>
            <tr>
              <th className="text-nowrap">口座番号</th>
              <td>{bank.deposit_type} {bank.account_number}</td>
            </tr>
            <tr>
              <th className="text-nowrap">口座名義</th>
              <td>{bank.account_name}</td>
            </tr>
          </tbody>
        </Table>
      ))}

      {props.bottomChildren}
      <button type="submit" className={styles.submitButton} disabled={isProcessing || !props.isValid} >
          {isProcessing ? 'Processing...' : '購入'}
      </button>
    </form>
  );
};

export default Bank;
